import { render, staticRenderFns } from "./GoldRecordItem.vue?vue&type=template&id=107ad238&scoped=true&"
import script from "./GoldRecordItem.vue?vue&type=script&lang=js&"
export * from "./GoldRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./GoldRecordItem.vue?vue&type=style&index=0&id=107ad238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ad238",
  null
  
)

export default component.exports